// Welche Seite der App gerade offen ist – über das Zeichen # in der Adresse
// (#/proben, #/geraete …). So braucht die App keinen Baustein fürs
// Seitenwechseln, und der Zurück-Knopf des Handys funktioniert von selbst.
//
// Seit E2, Schritt 4 auch: In welcher Umgebung läuft die App – gelesen aus
// dem Namen der Adresse, für den Test-Balken schon vor der Anmeldung.

import { useSyncExternalStore } from "react";
import type { Umgebung } from "@happy-energy/kern";

function lesen(): string {
  const roh = window.location.hash.replace(/^#/, "");
  return roh.startsWith("/") ? roh : `/${roh}`;
}

function abonnieren(melden: () => void): () => void {
  window.addEventListener("hashchange", melden);
  return () => window.removeEventListener("hashchange", melden);
}

export function useSeite(): string {
  return useSyncExternalStore(abonnieren, lesen, () => "/");
}

/**
 * Die Umgebung aus dem Namen der Adresse (`location.hostname`): Vor der
 * Anmeldung kennt die App sie noch nicht vom Server (`/api/ich`), der
 * orangefarbene Balken soll aber schon auf dem Anmeldebildschirm stehen –
 * sonst meldet sich jemand in der Test-Umgebung an und hält sie für echt.
 *  - doku-test.… und crm-test.… → „test“ (die Test-Umgebung am Server)
 *  - localhost, 127.0.0.1, [::1] → „entwicklung“ (am Laptop)
 *  - alles andere → „echt“
 * Nach der Anmeldung gilt, was der Server sagt.
 */
export function umgebungAusAdresse(hostname: string): Umgebung {
  const name = hostname.trim().toLowerCase();
  if (/^(doku|crm)-test\./.test(name)) return "test";
  if (name === "localhost" || name.endsWith(".localhost") || name === "127.0.0.1" || name === "[::1]" || name === "::1") {
    return "entwicklung";
  }
  return "echt";
}
